import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMachine } from '@xstate/react';

import { useDefaultCurrency } from '/src/hooks';
import { valueMachine, STATES } from '/src/features/goals/machines/wizard';
import { GoalValueWizard } from '/src/features/goals/components/wizard/GoalValueWizard';

export function Component() {
  const params = useParams();
  const navigate = useNavigate();
  const abTestId = params?.id ?? null;

  const { defaultCurrency } = useDefaultCurrency();

  const [, , service] = useMachine(valueMachine, {
    devTools: true,
    context: {
      isEditing: true,
      goalId: Number(params.goalId),
      previousPath: abTestId ? `/ab-tests/${abTestId}/goals` : `/goals/${params.goalId}`,
      defaultCurrency,
    },
  });

  useEffect(() => {
    const subscription = service.subscribe(async (state) => {
      if (state.matches(STATES.COMPLETED)) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }

      if (state.matches(STATES.CANCELLED)) {
        navigate(`/goals/${params.goalId}`, { replace: true });
      }
    });

    return subscription.unsubscribe;
  }, [navigate, params.goalId, service]);

  return <GoalValueWizard goalId={Number(params.goalId)} service={service} />;
}
